<section edsSpacing="xxl" edsGrid *ngIf="!isDebugMode">
  <div class="container container--wide">
    <ng-container *ngIf="!hideLibraryHeader">
      <div edsSpacing="xl">
        <ft-insights-filters
          [aggregation]="aggregations"
          [translationLabel]="translationLabel"
          [displayOptions]="displayOptions"
          (filtered)="onFiltered()"
          (searchTerm)="termSearch($event)"
        ></ft-insights-filters>
      </div>
    </ng-container>

    <div
      id="insightScrollPosition"
      edsFlexbox
      flexWrap="wrap-reverse"
      alignItems="center"
      justifyContent="space-between"
    >
      <div>
        <ng-container *ngIf="totalRecords">
          <p edsSpacing="none">
            {{ translationLabel?.showing }}
            <strong>{{ visibleRecords }}</strong> {{ translationLabel?.of }}
            <strong>{{ totalRecords }}</strong>
          </p>
        </ng-container>
      </div>
      <div edsFlexbox>
        <div *ngIf="displayOptions?.enableArchived">
          <eds-flyout-menu
            theme="basic"
            [title]="this.selectedArticleType"
            [items]="filtersData.items"
            widthSize="md"
            ariaLabelledby="BasicMenuControl"
            [isNonLinkableClickAction]="true"
            (menuItemSelectedWithIndexOutput)="selectArticleType($event)"
          ></eds-flyout-menu>
        </div>
        <div
          edsPadding
          [edsPaddingTop]="(isMobile$ | async) !== true ? 'none' : 'xs'"
        >
          <eds-toggle
            [toggleButtons]="filtersData.toggleButtons"
            [isNoWrap]="true"
            (toggleActive)="tabSelected($event)"
          ></eds-toggle>
        </div>
      </div>
    </div>
    <div edsSpacing="lg"></div>
    <div *ngIf="!results.length">
      <div>
        <p class="large bold">{{ translationLabel?.noRecordFound }}</p>
      </div>
    </div>

    <div>
      <!-- List View on desktop -->
      <div
        *ngIf="selectedTab === 'listView' && !isHandheld"
        edsSubGrid="layout-3"
        edsSubGridGap="xl"
      >
        <div>
          <ng-container *ngIf="results?.length">
            <div *ngFor="let result of results">
              <div edsSpacing="lg">
                <ng-container
                  *ngTemplateOutlet="
                    articleCard;
                    context: {
                      result: result,
                      isCompact: true
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </ng-container>
        </div>
        <div>
          <ng-container *ngIf="sideBarDocumentRef">
            <ng-container *ngTemplateOutlet="sidebar"></ng-container>
          </ng-container>
        </div>
      </div>

      <!-- List view on tablet and mobile -->
      <div *ngIf="selectedTab === 'listView' && isHandheld">
        <div>
          <ng-container *ngIf="results?.length">
            <div *ngFor="let result of results">
              <div edsSpacing="lg">
                <ng-container
                  *ngTemplateOutlet="
                    articleCard;
                    context: {
                      result: result,
                      isCompact: true
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Grid view -->
      <div *ngIf="selectedTab === 'gridView'">
        <ng-container *ngIf="!sideBarDocumentRef && results?.length">
          <div
            [edsSubGrid]="'layout-0'"
            edsSubGridTablet="layout-0"
            edsSubGridGap="md"
            edsSubGridTabletGap="md"
          >
            <div
              [edsSubGrid]="'layout-2'"
              edsSubGridTablet="layout-1"
              edsSubGridGap="md"
              edsSubGridTabletGap="md"
            >
              <div *ngFor="let result of results" edsSpacing="lg">
                <ng-container
                  *ngTemplateOutlet="
                    articleCard;
                    context: {
                      result: result,
                      isCompact: false
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="sideBarDocumentRef && results?.length">
          <div
            [edsSubGrid]="'layout-3'"
            edsSubGridTablet="layout-0"
            edsSubGridGap="md"
            edsSubGridTabletGap="md"
          >
            <div
              [edsSubGrid]="'layout-1'"
              edsSubGridTablet="layout-1"
              edsSubGridGap="md"
              edsSubGridTabletGap="md"
            >
              <ng-container
                *ngIf="
                  sideBarDocumentRef?.contentTop &&
                  sideBarDocumentRef?.contentBottom &&
                  !sideBarDocumentRef?.collections?.length
                "
              >
                <div
                  *ngFor="let result of results | slice: 0:2"
                  edsSpacing="lg"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      articleCard;
                      context: {
                        result: result,
                        isCompact: false
                      }
                    "
                  ></ng-container>
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                  sideBarDocumentRef?.contentTop &&
                  sideBarDocumentRef?.contentBottom &&
                  sideBarDocumentRef?.collections?.length
                "
              >
                <div
                  *ngFor="let result of results | slice: 0:4"
                  edsSpacing="lg"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      articleCard;
                      context: {
                        result: result,
                        isCompact: false
                      }
                    "
                  ></ng-container>
                </div>
              </ng-container>
            </div>
            <div *ngIf="!isHandheld">
              <div edsSpacing="xxl">
                <ng-container *ngTemplateOutlet="sidebar"></ng-container>
              </div>
            </div>
          </div>
          <div
            [edsSubGrid]="'layout-0'"
            edsSubGridTablet="layout-0"
            edsSubGridGap="md"
            edsSubGridTabletGap="md"
          >
            <div
              [edsSubGrid]="'layout-2'"
              edsSubGridTablet="layout-1"
              edsSubGridGap="md"
              edsSubGridTabletGap="md"
            >
              <ng-container *ngIf="results?.length">
                <ng-container
                  *ngIf="
                    sideBarDocumentRef?.contentTop &&
                    sideBarDocumentRef?.contentBottom &&
                    !sideBarDocumentRef?.collections?.length
                  "
                >
                  <div
                    *ngFor="let result of results | slice: 2"
                    edsSpacing="lg"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        articleCard;
                        context: {
                          result: result,
                          isCompact: false
                        }
                      "
                    ></ng-container>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="
                    sideBarDocumentRef?.contentTop &&
                    sideBarDocumentRef?.contentBottom &&
                    sideBarDocumentRef?.collections?.length
                  "
                >
                  <div
                    *ngFor="let result of results | slice: 4"
                    edsSpacing="lg"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        articleCard;
                        context: {
                          result: result,
                          isCompact: false
                        }
                      "
                    ></ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div edsSpacing="lg"></div>
    <div edsRow *ngIf="totalRecords > options.counters.pages">
      <eds-pagination
        edsCol
        [edsSpacing]="'lg'"
        [prevPageText]="translationLabel?.previous"
        [nextPageText]="translationLabel?.next"
        [pages]="totalPages"
        (pageChanged)="goToPage($event)"
      ></eds-pagination>
    </div>
    <div
      edsPadding
      edsPaddingTop="xxl"
      edsPaddingBottom="xl"
      *ngIf="isHandheld"
    >
      <ng-container *ngIf="sideBarDocumentRef">
        <ng-container *ngTemplateOutlet="sidebar"></ng-container>
      </ng-container>
    </div>
    <ng-template let-result="result" let-isCompact="isCompact" #articleCard>
      <eds-card-article
        [hasImage]="result._source?.imgSrc ? true : false"
        [imgSrc]="result._source?.imgSrc"
        [title]="result._source?.title"
        [description]="result._source?.description"
        [date]="result._source?.referenceDate"
        [href]="result._source?.relativePath"
        [isCompact]="isCompact"
        [logoLink]="result._source?.SIM?.logoSrc"
        [altLogoText]="result._source?.SIM?.logoAltText | titlecase"
        [logoTheme]="result._source?.SIM?.logoTheme"
        [subTitle]="
          result._source?.isArchived ? this.translationLabel?.archived : ''
        "
      >
      </eds-card-article>
      <ft-insights-tags [insightsTags]="result._source"></ft-insights-tags>
    </ng-template>
    <ng-template #sidebar>
      <ft-insights-sidebar
        [documentData]="sideBarDocumentRef"
        [page]="page"
        [enableTopFour]="displayOptions?.enableTopFour"
        [translationLabel]="translationLabel"
      >
      </ft-insights-sidebar>
    </ng-template>
  </div>
</section>
<ng-container *ngIf="isDebugMode">
  <ft-insights-report></ft-insights-report>
</ng-container>
